import {useAuthStore} from "@stores/auth";
import {useMenuStore} from "@stores/menu";
import {useDepositStore} from "@stores/deposit";
import {usePromotionStore} from "@stores/promotion";

export default function useNavbar() {
    const authStore = useAuthStore();
    const depositStore = useDepositStore();
    const promotionStore = usePromotionStore();

    const protectedRoutes = [
        "user-coupon",
        "user-bonus",
        "user-account",
        "user-document",
        "user-transaction",
        "user-password",
        "user-withdraw",
        "user-deposit",
        "user-deposit-id",
    ];

    const showButton = ref(false);
    let deferredPrompt = null;

    const handleInstallPrompt = (event) => {
        event.preventDefault();
        deferredPrompt = event;
        showButton.value = true;
    };

    const installApp = () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            deferredPrompt.userChoice.then((choiceResult) => {
                showButton.value = false;
                deferredPrompt = null;
            });
        }
    };

    onMounted(() => {
        window.addEventListener("beforeinstallprompt", handleInstallPrompt);
    });

    onBeforeUnmount(() => {
        window.removeEventListener("beforeinstallprompt", handleInstallPrompt);
    });

    const menuStore = useMenuStore();

    return {
        authStore,
        depositStore,
        promotionStore,
        showButton,
        handleInstallPrompt,
        installApp,
        menuStore
    };
}